import React, { Component } from 'react';
import NavLink from './NavLink';
import {Link} from 'react-router-dom'

class About extends Component {
render() {
return (
    <header>
		<Link className="logo" to="/">
            <img src="assets/img/logo.svg" alt="logo" />
        </Link>

		<nav>
			<ul>
				<li>
					<NavLink  className="nav-list" to="/about">O nas</NavLink>
				</li>

				<li>
					<NavLink  className="nav-list" to="/offer">Oferta</NavLink>
				</li>
			
				<li>
					<NavLink  className="nav-list" to="/gallery">Galeria</NavLink>
				</li>

				<li>
					<NavLink  className="nav-list" to="/contact">Kontakt</NavLink>
				</li>
			</ul>
		</nav>
        
		
	</header>
)
}
}
export default About;